// Modal functionality
function openModal(id) {
  var html = document.querySelector('html');
  var modalOutside = document.querySelector('#' + id + '.modal__outside');

  if (modalOutside) {
    html.classList.add('lock-scroll');
    modalOutside.classList.add('is-open');
  }
}

function closeModal() {
  var html = document.querySelector('html');
  var modalOutside = document.querySelector('.modal__outside.is-open');

  if (modalOutside) {
    html.classList.remove('lock-scroll');
    modalOutside.classList.remove('is-open');
  }
}

// Modal event listeners
var modalOutside = document.querySelectorAll('.modal__outside');
modalOutside.forEach(function (modal) {
  modal.addEventListener('click', function (e) {
    if (e.target.closest('.modal__close') || e.target.classList.contains('is-open')) {
      closeModal();
    }
  });
});

// MERV card selection
document.addEventListener('DOMContentLoaded', function () {
  var mervCards = document.querySelectorAll('.merv-card');

      mervCards.forEach(function (card) {
      card.addEventListener('click', function () {
        // Remove selected class from all cards
        mervCards.forEach(function (c) {
          c.classList.remove('selected');
          c.classList.add('unselected');
        });

        // Add selected class to clicked card
        this.classList.remove('unselected');
        this.classList.add('selected');

        // Update radio button
        var radioButton = this.querySelector('input[type="radio"]');
        if (radioButton) {
          radioButton.checked = true;
          // Check step completion when MERV is selected
          checkStepCompletion();
          // Trigger dimension change check when MERV is selected
          handleDimensionChange();
        }
      });
    });

  // No longer needed - ReCharge handles delivery options

  // Load saved dimensions from localStorage
  loadSavedDimensions();

  // Add event listeners for all dimension inputs
  var dimensionInputs = document.querySelectorAll('#length-main, #length-fraction, #width-main, #width-fraction, #depth-main');
  dimensionInputs.forEach(function(input) {
    input.addEventListener('change', function() {
      saveDimensionsToStorage();
      checkStepCompletion();
      handleDimensionChange();
    });
  });
  
  // Initial check on page load
  checkStepCompletion();

  // Add event listener for add to cart button
  var addToCartBtn = document.querySelector('.add-to-cart-btn');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', handleAddToCart);
  }
});

// Quantity controls
function decreaseQuantity() {
  var quantityValue = document.getElementById('quantity-value');
  var currentValue = parseInt(quantityValue.textContent);

  if (currentValue > 1) {
    quantityValue.textContent = currentValue - 1;
    updatePricing(currentValue - 1);
  }
}

function increaseQuantity() {
  var quantityValue = document.getElementById('quantity-value');
  var currentValue = parseInt(quantityValue.textContent);

  quantityValue.textContent = currentValue + 1;
  updatePricing(currentValue + 1);
}

function updatePricing(quantity) {
  // Use actual product price if available, otherwise fallback to hardcoded
  var basePricePerCase = getActualProductPrice() || 35.49;
  var filtersPerCase = 6;
  
  // Calculate total price
  var totalPrice = basePricePerCase * quantity;
  
  // Calculate cost per filter
  var costPerFilter = totalPrice / (quantity * filtersPerCase);

  // Update cost per filter display
  var costElement = document.querySelector('.cost-info');
  if (costElement) {
    costElement.textContent = 'Cost per filter: $' + costPerFilter.toFixed(2);
  }

  // Update add to cart button price
  var addToCartBtn = document.querySelector('.add-to-cart-btn');
  if (addToCartBtn) {
    addToCartBtn.textContent = 'Add to cart - $' + totalPrice.toFixed(2);
  }
}

// Get actual product price from found product or use fallback
function getActualProductPrice() {
  // Check if we have stored product price
  var addToCartBtn = document.querySelector('.add-to-cart-btn');
  if (addToCartBtn && addToCartBtn.dataset.basePrice) {
    return parseFloat(addToCartBtn.dataset.basePrice);
  }
  
  return 35.49; // Default fallback
}

// Update pricing from actual product data
function updatePricingFromProduct() {
  var quantity = parseInt(document.getElementById('quantity-value').textContent);
  updatePricing(quantity);
}

// Dimension validation
function validateDimensions() {
  var lengthMain = document.getElementById('length-main');
  var widthMain = document.getElementById('width-main');
  var depthMain = document.getElementById('depth-main');

  var isValid = lengthMain.value !== '' && widthMain.value !== '' && depthMain.value !== '';

  if (isValid) {
    console.log('Dimensions valid:', {
      length: lengthMain.value,
      width: widthMain.value,
      depth: depthMain.value,
    });
    // Here you would trigger product search or other functionality
  }

  return isValid;
}

// Product search and rendering functionality
var resultHandle = '';
var currHandle = resultHandle;
function predictQuery(queryTag, querySku) {
  console.log('Searching for:', queryTag, querySku);
  var resultContainer = document.querySelector('.add-to-cart-section');
  var addToCartBtn = document.querySelector('.add-to-cart-btn');
  
  // Show loading state
  addToCartBtn.textContent = 'Searching...';
  addToCartBtn.disabled = true;

currentString = querySku + ' OR ' + queryTag;
  console.log('Search string:', currentString);

  var searchObj = {
    q: currentString,
    'resources[type]': 'product',
    'resources[limit]': 10,
    'resources[options][unavailable_products]': 'last',
    'resources[options][fields]': 'tag,variants.sku',
  };

  var params = paramUrl(searchObj);
  fetch('/search/suggest.json?' + params)
    .then((response) => response.json())
    .then((suggestions) => {
      console.log('Search results:', suggestions);
      var resultCount = 0;
      var hasVariants = 0;
      var variantId = null;

      var resultTypes = Object.entries(suggestions.resources.results);
      console.log('Result types:', resultTypes);

      Object.keys(resultTypes).forEach(function (i) {
        var obj = resultTypes[i];
        var type = obj[0];
        var results = obj[1];

        console.log('Processing result type:', type, 'with', results.length, 'results');
        
        resultCount += results.length;
        if (resultCount !== 0) {
          var selectedIndex = 0;
          console.log('First result:', results[0]);
          
          if (!results[0].tags.join('').includes(queryTag)) {
            for (var i = 0; i < results.length; i++) {
              if (results[i].variants && results[i].variants.length) {
                selectedIndex = i;
                console.log('Found result with variants at index:', i);
                break;
              }
            }
       console.log(results.length);
          }
          
          resultHandle = results[selectedIndex].handle;
          console.log(resultHandle);
          hasVariants = results[selectedIndex].variants ? results[selectedIndex].variants.length : 0;
          console.log('Selected result:', results[selectedIndex]);
          console.log('Has variants:', hasVariants);
            
          if (hasVariants) {
            variantId = results[selectedIndex].variants[0].id;
            console.log('Selected variant ID:', variantId);
            var targetDiv = document.querySelector('.resultanc');
            var btnatc =  document.querySelector('.add-to-cart-btn');
              targetDiv.innerHTML = "";
               btnatc.setAttribute('style', 'display: block !important;');
          } else {
            console.log('No variants found, will use product ID as variant ID');
            // For products without variants, use the product ID
           
           if (results[selectedIndex].url){

           var targetDiv = document.querySelector('.resultanc');    
              // 2. Check if the element was found
              if (targetDiv) {
                var phandle = results[selectedIndex].title;
                var purl = results[selectedIndex].url;
                var step3 =   document.querySelector('.step-3-section');
                var step4 =   document.querySelector('.step-4-section');
                var btnatc =  document.querySelector('.add-to-cart-btn');
                var div3 = document.querySelector('.step-4-divider');
                var div4 = document.querySelector('.step-3-divider');
              step3.setAttribute('style', 'display: none !important;');
              step4.setAttribute('style', 'display: none !important;');
              btnatc.setAttribute('style', 'display: none !important;');
             div3.setAttribute('style', 'display: none !important;');
              div4.setAttribute('style', 'display: none !important;');
                // Insert the HTML string just before the closing tag (i.e., append it)
             targetDiv.innerHTML =  ` <h1> We found a standard size ${phandle} </h1> <br><a style="    background: #09196c;
    border: none;
    border-radius: 33px;
    height: 45px;
    width: 35%;
    font-family: Poppins, sans-serif;
    font-weight: 600;
    font-size: 16px;
    color: #fff;
    letter-spacing: .32px;
    display: block;
    text-align: center;
    padding-top: 10px;" href="https://airfiltersdelivered.com/${purl}"> View Product</a>`;
                 
                                }

           }
            
          }
        }
      });

      if (resultCount === 0) {
        addToCartBtn.textContent = 'No products found';
        addToCartBtn.disabled = true;
        return;
      }
      
      // Fetch actual product data to get correct variant ID
      fetchProductData(resultHandle, variantId);
    })
    .catch((error) => {
      console.error('Search error:', error);
      addToCartBtn.textContent = 'Search failed';
      addToCartBtn.disabled = true;
    });
}

function fetchProductData(productHandle, searchVariantId) {
  var addToCartBtn = document.querySelector('.add-to-cart-btn');
  console.log('Fetching product data for:', productHandle);
  console.log(searchVariantId);
  addToCartBtn.textContent = 'Loading product...';
  
  // First fetch the .js data
  var url = '/products/' + productHandle + '.js';
  
  fetch(url)
    .then(response => response.json())
    .then(product => {
      console.log('Product data:', product);
      
      var actualVariantId = null;
      var actualVariant = null;
      
      if (product.variants && product.variants.length > 0) {
        // Find an available variant
       
        
        var availableVariant = product.variants.find(v => v.id === searchVariantId);
        console.log(availableVariant.id);
        if (availableVariant) {
          actualVariantId = availableVariant.id;
          actualVariant = availableVariant;
          console.log('Using available variant ID:', actualVariantId, 'Title:', availableVariant.title);
        } else {
          // Use first variant even if not available
          actualVariantId = product.variants[0].id;
          actualVariant = product.variants[0];
          console.log('Using first variant ID (not available):', actualVariantId, 'Title:', product.variants[0].title);
        }
        
        console.log('All variants:', product.variants.map(v => ({id: v.id, title: v.title, available: v.available})));
      } else {
        console.error('No variants found in product data');
        addToCartBtn.textContent = 'Product not available';
        addToCartBtn.disabled = true;
        return;
      }
      
      // Calculate pricing from actual product data
      var quantity = parseInt(document.getElementById('quantity-value').textContent);
      var variantPrice = actualVariant.price / 100; // Convert from cents to dollars
      var finalPrice = variantPrice;
      
      var totalPrice = (finalPrice * quantity).toFixed(2);
      var costPerFilter = (finalPrice / 6).toFixed(2); // 6 filters per case
      
      // Update displays
      addToCartBtn.textContent = 'Add to cart - $' + totalPrice;
      addToCartBtn.disabled = false;
      
      var costElement = document.querySelector('.cost-info');
      if (costElement) {
        costElement.textContent = 'Cost per filter: $' + costPerFilter;
      }
      
      // Store product info for cart
      addToCartBtn.dataset.productHandle = productHandle;
      addToCartBtn.dataset.variantId = actualVariantId;
      addToCartBtn.dataset.basePrice = variantPrice;
      addToCartBtn.dataset.productId = product.id;
      
      // Fetch product HTML for ReCharge widget (like legacy does)
      if (product.id) {
        fetchProductHTMLForReCharge(productHandle, actualVariantId, product.id, actualVariant.price);
      }
    })
    .catch((error) => {
      console.error('Product fetch error:', error);
      addToCartBtn.textContent = 'Product load failed';
      addToCartBtn.disabled = true;
    });
}

// Fetch product HTML and initialize ReCharge (like legacy implementation)
function fetchProductHTMLForReCharge(productHandle, variantId, productId, productPrice) {
  // Fetch the product HTML with custom filter view
  var url = '/products/' + productHandle;
  
  // Check if URL already has 'custom' in it
  if (!url.includes('custom')) {
    url += '?view=custom-filter';
  }
  
  if (variantId) {
    url += (url.includes('?') ? '&' : '?') + 'variant=' + variantId;
  }
  
  console.log('Fetching product HTML for ReCharge:', url);
  
  fetch(url)
    .then(response => response.text())
    .then(html => {
      // Parse the HTML
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      
      // Find the product form
      var productForm = doc.querySelector('form[action="/cart/add"]');
      
      if (productForm) {
        // Show ReCharge container (Step 4)
        var rechargeContainer = document.querySelector('.recharge-widget-container');
        if (rechargeContainer) {
          rechargeContainer.style.display = 'block';
          // Animate the appearance
          setTimeout(function() {
            rechargeContainer.classList.add('step-visible');
          }, 10);
        }
        
        // Create a container using the same structure as main-product.liquid
        var tempContainer = document.createElement('div');
        tempContainer.className = 'product-info__block step-three-section';
        tempContainer.setAttribute('data-product-handle', productHandle);
        tempContainer.innerHTML = `
          <product-form>
            <form action="/cart/add" method="post" enctype="multipart/form-data" class="js-product-form js-product-form-main" id="product-form-recharge-${productId}">
              <input type="hidden" name="id" value="${variantId}"> 
              <div class="product-info__add-to-cart" style="display: none;">
                <div class="product-info__add-button">
                  <button type="submit" class="btn btn--primary" name="add">Add to cart</button>
                </div>
              </div>
            </form>
          </product-form>
          <div class="product__price" style="display: none;">
            <span class="price" data-product-price>$${(productPrice / 100).toFixed(2)}</span>
          </div>
        `;
        
        // Add the temp container to the ReCharge widget area
        var widgetContainer = document.getElementById('recharge-widget-container');
        if (widgetContainer) {
          widgetContainer.innerHTML = '';
          widgetContainer.appendChild(tempContainer);
        }
        
        // Initialize ReCharge widget
        setTimeout(function() {
          if (window.ReChargeWidget) {
            try {
              // First ensure the product-form web component is initialized
              var productFormEl = tempContainer.querySelector('product-form');
              if (productFormEl && productFormEl.init) {
                productFormEl.init();
              }
              
              // Create widget with the product ID
              window.ReChargeWidget.createWidget({ productId: productId });
              console.log('ReCharge widget initialized for product:', productId);
              
              // Monitor for widget creation and prevent it from hiding
              var checkInterval = setInterval(function() {
                var rcContainers = document.querySelectorAll('.rc-container, .rc-widget');
                if (rcContainers.length > 0) {
                  console.log('ReCharge widget found, ensuring visibility');
                  clearInterval(checkInterval);
                  
                  rcContainers.forEach(function(container) {
                    // Force visibility
                    container.style.opacity = '1';
                    container.style.visibility = 'visible';
                    container.style.display = 'block';
                    
                    // Watch for style changes and prevent hiding
                    var observer = new MutationObserver(function(mutations) {
                      mutations.forEach(function(mutation) {
                        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                          var target = mutation.target;
                          if (target.style.display === 'none' || 
                              target.style.visibility === 'hidden' || 
                              target.style.opacity === '0') {
                            console.log('Preventing ReCharge from hiding');
                            target.style.display = 'block';
                            target.style.visibility = 'visible';
                            target.style.opacity = '1';
                          }
                        }
                      });
                    });
                    
                    observer.observe(container, {
                      attributes: true,
                      attributeFilter: ['style']
                    });
                  });
                }
              }, 100);
              
              // Stop checking after 5 seconds
              setTimeout(function() {
                clearInterval(checkInterval);
              }, 5000);
            } catch (error) {
              console.error('ReCharge widget error:', error);
            }
          } else {
            console.log('ReCharge widget not available yet, waiting...');
            // Try again if ReCharge isn't loaded yet
            setTimeout(arguments.callee, 500);
          }
        }, 200);
      }
    })
    .catch(error => {
      console.error('Failed to fetch product HTML:', error);
    });
}

function paramUrl(obj) {
  return Object.keys(obj)
    .map(function (key) {
      return key + '=' + encodeURIComponent(obj[key]);
    })
    .join('&');
}

function fullDimensions() {
  var mervSelected = document.querySelector('input[name="merv"]:checked');
  var lengthMain = document.getElementById('length-main').value;
  var lengthFraction = document.getElementById('length-fraction').value;
  var widthMain = document.getElementById('width-main').value;
  var widthFraction = document.getElementById('width-fraction').value;
  var depth = document.getElementById('depth-main').value;
  
  var _length = parseFloat(lengthMain) + parseFloat(lengthFraction);
  var _width = parseFloat(widthMain) + parseFloat(widthFraction);
  var _depth = parseFloat(depth);
  
  var lengthDisplay = lengthMain + (lengthFraction != 0 ? ' ' + document.getElementById('length-fraction').options[document.getElementById('length-fraction').selectedIndex].text : '');
  var widthDisplay = widthMain + (widthFraction != 0 ? ' ' + document.getElementById('width-fraction').options[document.getElementById('width-fraction').selectedIndex].text : '');
  
  var fullDimensions = 
    (_length < _width ? lengthDisplay : widthDisplay) +
    ' x ' +
    (_width > _length ? widthDisplay : lengthDisplay) +
    ' x ' +
    _depth +
    ' ' +
    'MERV' +
    mervSelected.value;
    
  return fullDimensions;
}

function rangeFormat(num) {
  var s = Math.floor(num) + '';
  while (s.length < 4) s = '0' + s;
  var subS = s.substring(0, 2);
  if (subS == 00) subS = '01'; // Compare as numbers like legacy
  return subS + '99';
}

function handleDimensionChange() {
  console.log('Dimension change triggered');
  var lengthMain = document.getElementById('length-main');
  var widthMain = document.getElementById('width-main');
  var depthMain = document.getElementById('depth-main');
  var mervSelected = document.querySelector('input[name="merv"]:checked');
  
  console.log('Length:', lengthMain?.value, 'Width:', widthMain?.value, 'Depth:', depthMain?.value);
  console.log('MERV selected:', mervSelected?.value);
  
  var areEmpty = lengthMain.value !== '' && widthMain.value !== '' && depthMain.value !== '';
  
  // Check if steps 1 and 2 are complete
  checkStepCompletion();
  
  // Validate inputs if filled
  if (areEmpty) {
    var hasError = false;
    var inputs = [lengthMain, widthMain, depthMain];
    
    for (var i = 0; i < inputs.length; i++) {
      var isValid = inputs[i].checkValidity();
      if (!isValid) {
        inputs[i].reportValidity();
        hasError = true;
        break;
      }
    }
    
    if (hasError) return;
  }
  
  if (areEmpty && mervSelected) {
    console.log('All dimensions filled, starting search...');
    var lengthFraction = document.getElementById('length-fraction').value;
    var widthFraction = document.getElementById('width-fraction').value;
    
    var _length = parseFloat(lengthMain.value) + parseFloat(lengthFraction);
    var _width = parseFloat(widthMain.value) + parseFloat(widthFraction);
    var _depth = parseFloat(depthMain.value);
    
    var _qTag = 'ActualSize:[' + mervSelected.value + '][' + _length.toFixed(3) + ']x[' + _width.toFixed(3) + ']x[' + _depth.toFixed(3) + ']';
    
    var _sku_prefix = mervSelected.dataset.sku || 'AF';
    var _isCD = [_length, _width].every((k) => k > 23.5) || [_length, _width].some((k) => k > 25) ? 'CD' : 'CS';
    var _range = rangeFormat(_length * _width);
    var _qSku = _sku_prefix + _isCD + '.' + '0' + _depth + _range;
    console.log("range:" + _range);
    console.log("_length" + _length);
    console.log("_width:" + _width);
    predictQuery(_qTag, _qSku);
  }
}

// Check if steps are complete and show/hide subsequent steps
function checkStepCompletion() {
  var lengthMain = document.getElementById('length-main');
  var widthMain = document.getElementById('width-main');
  var depthMain = document.getElementById('depth-main');
  var mervSelected = document.querySelector('input[name="merv"]:checked');
  
  var step3Section = document.querySelector('.step-3-section');
  var step4Section = document.querySelector('.step-4-section');
  var addToCartSection = document.querySelector('.add-to-cart-section');
  
  // Dividers
  var step2Divider = document.querySelector('.step-2-divider');
  var step3Divider = document.querySelector('.step-3-divider');
  var step4Divider = document.querySelector('.step-4-divider');
  
  // Check if dimensions are filled (Step 1)
  var dimensionsFilled = lengthMain.value !== '' && widthMain.value !== '' && depthMain.value !== '';
  
  // Check if MERV is selected (Step 2)
  var mervIsFilled = mervSelected !== null;
  
  // Show/hide Step 3 based on Steps 1 and 2
  if (dimensionsFilled && mervIsFilled) {
    // Show Step 3 and its divider
    if (step2Divider) step2Divider.style.display = 'block';
    if (step3Section) {
      step3Section.style.display = 'block';
      // Animate the appearance
      setTimeout(function() {
        step3Section.classList.add('step-visible');
      }, 10);
    }
    if (step3Divider) step3Divider.style.display = 'block';
    
    // Show add to cart section (will wait for product to be found for Step 4)
    if (addToCartSection) {
      addToCartSection.style.display = 'flex';
      setTimeout(function() {
        addToCartSection.classList.add('step-visible');
      }, 10);
    }
    if (step4Divider) step4Divider.style.display = 'block';
  } else {
    // Hide Step 3, 4, dividers and add to cart
    if (step2Divider) step2Divider.style.display = 'none';
    if (step3Section) {
      step3Section.style.display = 'none';
      step3Section.classList.remove('step-visible');
    }
    if (step3Divider) step3Divider.style.display = 'none';
    if (step4Section) {
      step4Section.style.display = 'none';
      step4Section.classList.remove('step-visible');
    }
    if (step4Divider) step4Divider.style.display = 'none';
    if (addToCartSection) {
      addToCartSection.style.display = 'none';
      addToCartSection.classList.remove('step-visible');
    }
  }
}

// Add to cart functionality
function handleAddToCart() {
  console.log('Add to cart clicked');
  var addToCartBtn = document.querySelector('.add-to-cart-btn');
  var productHandle = addToCartBtn.dataset.productHandle;
  var variantId = addToCartBtn.dataset.variantId;
  var quantity = parseInt(document.getElementById('quantity-value').textContent);
  
  console.log('Product handle:', productHandle);
  console.log('Variant ID:', variantId);
  console.log('Quantity:', quantity);
  
  if (!productHandle) {
    alert('Please select filter dimensions and MERV rating first');
    return;
  }
  
  // Check if ReCharge subscription is selected
  var rcWidget = document.querySelector('.rc-widget');
  var rcSelectedOption = rcWidget ? rcWidget.querySelector('.rc-option--active input[type="radio"]') : null;
  var isSubscription = rcSelectedOption && rcSelectedOption.value !== 'onetime';
  
  console.log('ReCharge widget found:', !!rcWidget);
  console.log('Selected option:', rcSelectedOption);
  console.log('Selected value:', rcSelectedOption ? rcSelectedOption.value : 'none');
  console.log('Is subscription:', isSubscription);
  
  // Get cart drawer reference
  var cartDrawer = document.querySelector('cart-drawer');
  
  // Build cart data for form submission (like product-form.js does)
  var formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', quantity);
  formData.append('properties[Custom Size]', fullDimensions());
  formData.append('properties[_Pack_Size]',  6);
  formData.append('properties[_Shipping_Leadtime]', '5');
  formData.append('properties[Pack Size]', 6);
  // Add ReCharge subscription properties if selected
  if (isSubscription && rcSelectedOption) {
    // Get the selling plan ID from ReCharge widget
    // The actual selling plan ID is in the name attribute: selling_plan_XXXXXX
    var sellingPlanName = rcSelectedOption.name;
    console.log('Selling plan name attribute:', sellingPlanName);
    
    if (sellingPlanName && sellingPlanName.startsWith('selling_plan_')) {
      // Extract the numeric ID from the name attribute
      var sellingPlanId = sellingPlanName.replace('selling_plan_', '');
      console.log('Extracted selling plan ID:', sellingPlanId);
      
      // Shopify expects just the numeric ID as a string
      formData.append('selling_plan', sellingPlanId);
      console.log('Adding selling plan to cart:', sellingPlanId);
    } else {
      console.error('Could not extract selling plan ID from:', sellingPlanName);
    }
  }
  
  // Add sections to fetch (cart icon and drawer)
  var sections = 'cart-icon-bubble';
  if (cartDrawer) {
    sections += ',' + cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '');
  }
  formData.append('sections', sections);
  formData.append('sections_url', window.location.pathname);
  
  console.log('Form data being sent:', Object.fromEntries(formData));
  
  // Add to cart
  addToCartBtn.textContent = 'Adding...';
  addToCartBtn.disabled = true;
  
  // Get old cart data before adding (for custom events)
  var oldCartPromise = fetch('/cart.js').then(response => response.json());
  
  oldCartPromise.then(oldCartData => {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
    .then(response => {
      console.log('Cart response status:', response.status);
      if (!response.ok) {
        return response.text().then(text => {
          console.error('Cart response error:', text);
          throw new Error('Cart add failed: ' + response.status + ' - ' + text);
        });
      }
      return response.json();
    })
    .then(data => {
      console.log('Cart add success:', data);
      addToCartBtn.textContent = 'Added to cart!';
      
      // Update cart icon count (like product-form.js does)
      updateCartIcon(data);
      
      // Update cart drawer and open it with delay (like product-form.js does)
      setTimeout(() => {
        if (cartDrawer) {
          cartDrawer.renderContents(data, true);
        }
      }, 700);
      
      // Get new cart data and dispatch custom events
      fetch('/cart.js')
        .then(response => response.json())
        .then(newCartData => {
          var itemInOldCart = oldCartData.items.filter(
            item => item.variant_id === data.variant_id
          )[0];
          
          // Dispatch appropriate custom event
          if (itemInOldCart) {
            document.dispatchEvent(new CustomEvent('on:line-item:change', {
              bubbles: true,
              detail: {
                cart: newCartData,
                variantId: data.variant_id,
                oldQuantity: itemInOldCart.quantity,
                newQuantity: (itemInOldCart.quantity === data.quantity)
                  ? itemInOldCart.quantity : data.quantity
              }
            }));
          } else {
            document.dispatchEvent(new CustomEvent('on:cart:add', {
              bubbles: true,
              detail: {
                cart: newCartData,
                variantId: data.variant_id
              }
            }));
          }
        });
      
      setTimeout(() => {
        var basePrice = getActualProductPrice();
        var totalPrice = (basePrice * quantity).toFixed(2);
        addToCartBtn.textContent = 'Add to cart - $' + totalPrice;
        addToCartBtn.disabled = false;
      }, 2000);
    });
  })
  .catch((error) => {
    console.error('Add to cart error:', error);
    addToCartBtn.textContent = 'Add to cart failed';
    
    // Dispatch error event
    document.dispatchEvent(new CustomEvent('on:cart:error', {
      bubbles: true,
      detail: {
        error: error.message
      }
    }));
    
    setTimeout(() => {
      var basePrice = getActualProductPrice();
      var totalPrice = (basePrice * quantity).toFixed(2);
      addToCartBtn.textContent = 'Add to cart - $' + totalPrice;
      addToCartBtn.disabled = false;
    }, 2000);
  });
}

// Update cart icon count (copied from product-form.js)
function updateCartIcon(data) {
  var cartIconBubble = document.getElementById('cart-icon-bubble');
  if (cartIconBubble && data.sections && data.sections['cart-icon-bubble']) {
    cartIconBubble.innerHTML = data.sections['cart-icon-bubble'];
  }
}

// Local Storage Functions
function saveDimensionsToStorage() {
  var dimensions = [
    document.getElementById('length-main').value,
    document.getElementById('length-fraction').value,
    document.getElementById('width-main').value,
    document.getElementById('width-fraction').value,
    document.getElementById('depth-main').value
  ];
  
  localStorage.setItem('dimensionsFilter', dimensions.join('|'));
}

function loadSavedDimensions() {
  var savedDimensions = localStorage.getItem('dimensionsFilter');
  if (savedDimensions) {
    var dimensionValues = savedDimensions.split('|');
    var dimensionInputs = [
      document.getElementById('length-main'),
      document.getElementById('length-fraction'),
      document.getElementById('width-main'),
      document.getElementById('width-fraction'),
      document.getElementById('depth-main')
    ];
    
    dimensionInputs.forEach(function(input, index) {
      if (input && dimensionValues[index]) {
        input.value = dimensionValues[index];
      }
    });
    
    // Trigger dimension change check after loading
    setTimeout(function() {
      handleDimensionChange();
    }, 100);
  } else {
    // Save initial dimensions if they have default values
    saveDimensionsToStorage();
  }
}

// Range formatting function (from legacy)
function rangeFormat(num) {
  var s = Math.floor(num) + '';
  while (s.length < 4) s = '0' + s;
  var subS = s.substring(0, 2);
  if (subS == 00) subS = '01'; // Compare as numbers like legacy
  return subS + '99';
}

// No longer needed - ReCharge initialization is handled in fetchProductHTMLForReCharge

// Dimension change listeners are now handled in the main DOMContentLoaded event above 